import { render, staticRenderFns } from "./DataArchiving.vue?vue&type=template&id=f0c8014e&"
import script from "./DataArchiving.vue?vue&type=script&lang=js&"
export * from "./DataArchiving.vue?vue&type=script&lang=js&"
import style0 from "./DataArchiving.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports